module.exports = "<h1></h1>\r\n<div class=\"row\">\r\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><h2>Board</h2></div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-6 col-sm-6 col-xs-12\" *ngFor=\"let device of deviceList\">\r\n        <device-history [deviceModel]=\"device\"></device-history>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/devices-history/devices-history.component.html
// module id = ./src/app/components/devices-history/devices-history.component.html
// module chunks = main